import preval from "preval.macro"

export const BUILD_TIME_STAMP = preval`module.exports = ((d) => \`\${d.getFullYear()}\${(d.getMonth()+1).toString().padStart(2, '0')}\${d.getDate().toString().padStart(2, '0')}_\${d.getHours().toString().padStart(2, '0')}\${d.getMinutes().toString().padStart(2, '0')}\`)(new Date());`

export const APP_NAME = "Kairos" as const
export const パスワード強度 = [
  "とても脆弱",
  "脆弱",
  "弱い",
  "妥当",
  "強固",
] as const
export const 一日最大配送数 = 8 as const
export const 事務センター部所コード = "1030" as const
export const 請求担当追加社員コード１ = "7205" as const
export const 請求担当追加社員コード２ = "7066" as const
export const 請求担当追加社員コード３ = "7167" as const
export const ダミー荷主適用品コード頭文字 = "9" as const
export const ダミー荷主コード = "99901" as const
export const 自由入力品コード = "99999" as const
export const 制約エラーコード = "DW23503" as const

const ISO8601_DATE_REGEX =
  /^\d{4}-?\d\d-?\d\d(?:T\d\d(?::?\d\d(?::?\d\d(?:\.\d+)?)?)?(?:Z|[+-]\d\d:?\d\d)?)?$/

const TIME_REGEX = /^([0-1][0-9]|[2][0-3]):[0-5][0-9]$/
const TIME_REGEX_NOT_COLON = /^([0-1][0-9]|[2][0-3])[0-5][0-9]$/
const TIME_REGEX_THREE_DIGITS = /^[0-9][0-5][0-9]$/

// 荷主コード
export const 大陽日酸株式会社_ロジスティクスセンター = "41071" as const
export const 大陽日酸株式会社 = "41073" as const
export const 大陽日酸株式会社_運送料_表紙分割コード = "1" as const

export const トクヤマエムテック_荷主コード = "45050" as const
export const 備北粉化工業_荷主コード = "62040" as const
export const 備北粉化工業_運送料_表紙分割コード = "1" as const
export const 備北粉化工業_H90HS_品コード = "14120" as const
export const 備北粉化工業_H90HS_掛率 = 0.78 as const
export const 備北粉化工業_S97_品コード = "14430" as const
export const 備北粉化工業_S97_掛率 = 0.75 as const

/**
 * SYプロモーション特殊条件群
 * 荷主コードと、卸先コード、車番、乗務員コードが一致するとき
 * 請求付帯料は10000で固定となる。また、乗務員付帯料に請求付帯料が連動しなくなる
 */
export const SYプロモーション特殊条件 = {
  荷主コード: "14110",
  // 2024/4 HA3から NA8に変更
  卸先コード: "NA8",
  車番: "1744",
  // 乗務員→ 680須之内　浩一、856野口　秀也
  乗務員コード: ["680", "856"] as string[],
  付帯料: 10000,
  請求備考: "タンク洗浄料",
} as const

// 登録可能最大点呼回数
export const 登録可能最大点呼回数 = 3

// falseが操作不可
export const 旧乗務員出勤簿系操作不可フラグ = false

const constants = {
  APP_NAME,
  一日最大配送数,
  事務センター部所コード,
  請求担当追加社員コード１,
  請求担当追加社員コード２,
  請求担当追加社員コード３,
  ダミー荷主適用品コード頭文字,
  ダミー荷主コード,
  自由入力品コード,
  制約エラーコード,
  ISO8601_DATE_REGEX,
  TIME_REGEX,
  TIME_REGEX_NOT_COLON,
  TIME_REGEX_THREE_DIGITS,
  大陽日酸株式会社_ロジスティクスセンター,
  大陽日酸株式会社,
  大陽日酸株式会社_運送料_表紙分割コード,
  トクヤマエムテック_荷主コード,
  備北粉化工業_荷主コード,
  備北粉化工業_運送料_表紙分割コード,
  備北粉化工業_H90HS_品コード,
  備北粉化工業_H90HS_掛率,
  備北粉化工業_S97_品コード,
  備北粉化工業_S97_掛率,
  SYプロモーション特殊条件,
  登録可能最大点呼回数,
  旧乗務員出勤簿系操作不可フラグ,
}

export default constants
